import { Link } from 'react-router-dom'
import { Download, Mail } from 'lucide-react'
import { DJ_NAME } from '../data'
import { useMediaQuery, breakpoints } from '../hooks/useMediaQuery'

const BOOKING_TYPES = ['Festivals', 'Clubs', 'Private Events', 'Weddings', 'Corporate', 'Sporting Events']

export default function BookingCTA() {
  const isDesktop = useMediaQuery(breakpoints.md)

  return (
    <section style={{ padding: '0 20px 80px', background: 'var(--ink)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div
          style={{
            border: '1px solid var(--border)',
            padding: isDesktop ? '60px 56px' : '36px 24px',
            display: 'flex',
            flexDirection: isDesktop ? 'row' : 'column',
            gap: '32px',
            alignItems: isDesktop ? 'center' : 'flex-start',
            background: 'linear-gradient(135deg, #141109 0%, var(--ink) 100%)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {[200, 130].map((size, i) => (
            <div key={i} style={{ position: 'absolute', top: -size / 2, right: -size / 2, width: size, height: size, borderRadius: '50%', border: `1px solid rgba(200,169,110,${0.05 + i * 0.02})`, pointerEvents: 'none' }} />
          ))}

          <div style={{ position: 'relative', flex: 1 }}>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: '10px', letterSpacing: '4px', textTransform: 'uppercase', color: 'var(--gold)', opacity: 0.8, marginBottom: '14px' }}>
              {BOOKING_TYPES.join(' · ')}
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: isDesktop ? 'clamp(36px, 4vw, 52px)' : '36px', textTransform: 'uppercase', color: 'var(--cream)', lineHeight: 1, marginBottom: '16px' }}>
              Book {DJ_NAME}
            </h2>
            <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: '15px', color: 'var(--muted)', maxWidth: '460px', lineHeight: 1.7 }}>
              Every show is built for the room, the crowd, and the moment. Let's talk about yours.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: isDesktop ? 'center' : 'flex-start', position: 'relative', zIndex: 1, flexShrink: 0 }}>
            <Link to="/contact" className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
              <Mail size={14} />
              Send Booking Request
            </Link>
            <Link
              to="/epk"
              style={{ fontFamily: 'var(--font-display)', fontSize: '10px', letterSpacing: '3px', textTransform: 'uppercase', color: 'rgba(242,236,224,0.3)', textDecoration: 'underline', textUnderlineOffset: '3px', display: 'flex', alignItems: 'center', gap: '6px', transition: 'color 0.2s' }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--cream)')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(242,236,224,0.3)')}
            >
              <Download size={12} />
              Download Press Kit (EPK)
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
